/**
 * The signed copy of a contract, kept in this browser so it can be opened
 * here whatever the platform did with it. The platform's copy — when it took
 * one — is a restricted revision in the document library, and that is the one
 * the rest of the airport sees; this is the reader's own.
 */
const DB = "sky.contract-files";
const STORE = "files";

function open(): Promise<IDBDatabase> {
  return new Promise((res, rej) => {
    if (typeof indexedDB === "undefined") return rej(new Error("this browser keeps no local store"));
    const rq = indexedDB.open(DB, 1);
    rq.onupgradeneeded = () => {
      if (!rq.result.objectStoreNames.contains(STORE)) rq.result.createObjectStore(STORE);
    };
    rq.onsuccess = () => res(rq.result);
    rq.onerror = () => rej(rq.error);
  });
}

export async function keepFile(key: string, blob: Blob): Promise<boolean> {
  try {
    const db = await open();
    await new Promise<void>((res, rej) => {
      const r = db.transaction(STORE, "readwrite").objectStore(STORE).put(blob, key);
      r.onsuccess = () => res();
      r.onerror = () => rej(r.error);
    });
    return true;
  } catch {
    return false;
  }
}

export async function readFile(key: string): Promise<Blob | null> {
  try {
    const db = await open();
    return await new Promise((res, rej) => {
      const r = db.transaction(STORE, "readonly").objectStore(STORE).get(key);
      r.onsuccess = () => res((r.result as Blob) ?? null);
      r.onerror = () => rej(r.error);
    });
  } catch {
    return null;
  }
}
